import Checkbox from 'components/Form/components/Checkbox'
import DateInput from 'components/Form/components/DateInput'
import SelectInput from 'components/Form/components/SelectInput'
import TextInput from 'components/Form/components/TextInput'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
// import moment from 'moment'
import React, { Component, PropTypes } from 'react'
import * as personalInfoSchema from 'schemas/forms/EditPersonalInfo'
import { validateAll } from 'utils/validators'
import styles from './EditPersonalInfoView.scss'
import constants from 'constants'
// import moment from 'moment'
import { format, parse } from 'date-fns'

import {
  formInit,
  formReset,
  formSubmit,
  formUpdate,
} from 'actions/forms'

class EditPersonalInfoView extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    // formUpdate: PropTypes.func,
    // formInit: PropTypes.func,
    // formSubmit: PropTypes.func,
    // formReset: PropTypes.func,
    frequencies: PropTypes.array,
    groupsAndEntities: PropTypes.array,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hasFetched: PropTypes.bool,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    serviceTypes: PropTypes.array,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
    personalInfo: PropTypes.object.isRequired,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
  }
  componentWillMount() {
    const formFields = personalInfoSchema.formFields

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.EditPersonalInfo// TBC
    const modalChanged = modalCreated && nextProps.modals.EditPersonalInfo.show !== this.props.modals.EditPersonalInfo.show
    const modalNotVisible = modalCreated && !nextProps.modals.EditPersonalInfo.show
    const modalVisible = modalCreated && nextProps.modals.EditPersonalInfo.show

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }
    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      // if (nextProps.currentEntityId) {
      //   this._handleChange('groupOrEntity', nextProps.currentEntityId)
      // }
      // this._handleChange('reminders', true)
      // this.props.dispatch(loadRequestSignatureMeta())
      if (this.props.personalInfo.personalInfo.length > 0) {
        const spouseDateOfBirth = (this.props.personalInfo.personalInfo[0].spouse_partner_birth_date ?
          format(parse(this.props.personalInfo.personalInfo[0].spouse_partner_birth_date, constants.DATE_FORMAT.STANDARD_ISO_TIME, new Date()), constants.DATE_FORMAT.STANDARD_AU_NOTIME) : '')
        this._handleChange('status', this.props.personalInfo.personalInfo[0].status)
        this._handleChange('drawDownStartDate', (this.props.personalInfo.personalInfo[0].draw_down_start_date ? this.props.personalInfo.personalInfo[0].draw_down_start_date : ''))
        this._handleChange('drawDownEndDate', (this.props.personalInfo.personalInfo[0].draw_down_end_date ? this.props.personalInfo.personalInfo[0].draw_down_end_date : ''))
        this._handleChange('boardMember', this.props.personalInfo.personalInfo[0].board_member)
        this._handleChange('otherName', this.props.personalInfo.personalInfo[0].other_name)
        this._handleChange('pensionAccrualDate', (this.props.personalInfo.personalInfo[0].pension_accrual_date ? this.props.personalInfo.personalInfo[0].pension_accrual_date : ''))
        this._handleChange('secondedTo', this.props.personalInfo.personalInfo[0].seconded_to)
        this._handleChange('secondee', this.props.personalInfo.personalInfo[0].secondee)
        this._handleChange('spouseFullLegalName', this.props.personalInfo.personalInfo[0].spouse_partner_name)
        this._handleChange('spouseDateOfBirth', (this.props.personalInfo.personalInfo[0].spouse_partner_birth_date ? spouseDateOfBirth : ''))
        this._handleChange('directorId', this.props.personalInfo.personalInfo[0].director_id)
        this._handleChange('allocatedPartnerTaxManager', this.props.personalInfo.personalInfo[0].allocated_partner_tax_manager)
      }
    }
  }

  _schema = () => {
    const obj = {}
    personalInfoSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    // debugger;
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })
    data.employee_id = this.props.personalInfo.personalInfo[0].employee_id
    // data.loginname = this.props.personalInfo.personalInfo[0].loginname

    // Validate all the forms fields and return any errors
    const errors = validateAll(personalInfoSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }
  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }
  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
        Create state value obj
        Reset error handling (Stops error check on focus changes)
      */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
        Create state value obj
        Reset error handling (Stops error check on focus changes)
      */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    // return form.beneficiaryName.value && form.type.value && form.dob.value && form.amountType.value

    // if (this.state.showSignedUpload) {
    //   return !!form.groupOrEntity.value

    // }
  }
  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      // frequencies,
      // groupsAndEntities,
      modals,
      // serviceTypes,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched

    // const serviceTypeOptions = serviceTypes.map(({ name }) => ({ value: name, label: name }))

    // const canSubmit = form.beneficiaryName.value && form.type.value && form.dob.value

    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="EditPersonalInfo"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>

          {/*
                  <Form
                        id={this.props.id}
                        ctaText="Submit"
                        schema={addBeneficiarySchema}
                        //data={this.props.user}
                        completeText="Submitted"
                        submittingText="Sending"
                        handleFormSubmit={this._handleSubmit}
                        //secondaryCta={secondaryCta}
                      />
                  */}

          {form && (!this.props.personalInfo.isFetching) && this.props.personalInfo.personalInfo && (this.props.personalInfo.personalInfo.length > 0) &&
            <form
              className={styles.form}
              id={this.props.id}
              noValidate="novalidate"
              onSubmit={this._handleSubmit}
            >
              {/* <div className={styles.sectionHeader}>
                                Beneficiary details
                            </div> */}
              <fieldset >
                <ul>
                  <div className={styles.sectionHeader}>
                  Personal data
                  </div>
                  <TextInput
                    {...schema.preferredName}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].preferred_name) ? this.props.personalInfo.personalInfo[0].preferred_name : '-'}
                  />
                  <TextInput
                    {...schema.DOB}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                      // text={(this.props.personalInfo.personalInfo[0].birth_date) ? moment(this.props.personalInfo.personalInfo[0].birth_date).format('DD MMM YYYY') : '-'}
                    text={(this.props.personalInfo.personalInfo[0].birth_date) ? format(new Date(this.props.personalInfo.personalInfo[0].birth_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}
                  />
                  <TextInput
                    {...schema.POB}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].birth_place) ? this.props.personalInfo.personalInfo[0].birth_place : '-'}
                  />
                  <TextInput
                    {...schema.gender}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].gender) ? this.props.personalInfo.personalInfo[0].gender : '-'}
                  />
                  <TextInput
                    {...schema.TFN}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].TFN) ? this.props.personalInfo.personalInfo[0].TFN : '-'}
                  />
                  <TextInput
                    {...schema.primaryCostCentreCode}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].cost_centre_code) ? this.props.personalInfo.personalInfo[0].cost_centre_code : '-'}
                  />
                  <TextInput
                    {...schema.costCentreEffectiveDate}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].cost_centre_effective_date) ?
                      format(new Date(this.props.personalInfo.personalInfo[0].cost_centre_effective_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : ''}
                  />
                  <TextInput
                    {...schema.peopleSoftCompany}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].peoplesoft_company) ? this.props.personalInfo.personalInfo[0].peoplesoft_company : '-'}
                  />
                  <TextInput
                    {...schema.jobCode}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].job_code) ? this.props.personalInfo.personalInfo[0].job_code : '-'}
                  />
                  <TextInput
                    {...schema.Email}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].email_id) ? this.props.personalInfo.personalInfo[0].email_id : '-'}
                  />
                  <TextInput
                    {...schema.businessTitle}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].business_title) ? this.props.personalInfo.personalInfo[0].business_title : '-'}
                  />
                  <TextInput
                    {...schema.antecendentName}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={(this.props.personalInfo.personalInfo[0].antecedent_name) ? this.props.personalInfo.personalInfo[0].antecedent_name : '-'}
                  />
                  <TextInput
                    {...schema.dateOfAdmission}
                      // error={form.dob.error}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].DateofAdmissiontoPartnership) ? this.props.personalInfo.personalInfo[0].DateofAdmissiontoPartnership : ''}
                    handleChange={this._handleChange}
                    value={form.dateOfAdmission.value}
                  />
                  <TextInput
                    {...schema.dateOfRetirement}
                      // error={form.dob.error}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].retirement_date) ? this.props.personalInfo.personalInfo[0].retirement_date : ''}
                    handleChange={this._handleChange}
                    value={form.dateOfRetirement.value}
                  />
                  <TextInput
                    {...schema.antecedentDate}
                      // error={form.dob.error}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].antecedent_date) ? this.props.personalInfo.personalInfo[0].antecedent_date : ''}
                    handleChange={this._handleChange}
                    value={form.antecedentDate.value}
                  />
                  <TextInput
                    {...schema.pensionCommencementDate}
                      // error={form.dob.error}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].DateofCommencementofPension) ? this.props.personalInfo.personalInfo[0].DateofCommencementofPension : ''}
                    handleChange={this._handleChange}
                    value={form.pensionCommencementDate.value}
                  />
                  <TextInput
                    {...schema.pensionEndDate}
                      // error={form.dob.error}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].EndDateofPensionPayments) ? this.props.personalInfo.personalInfo[0].EndDateofPensionPayments : ''}
                    handleChange={this._handleChange}
                    value={form.pensionEndDate.value}
                  />
                  <li>
                    <SelectInput
                      {...schema.status}
                      handleChange={this._handleSelectChange}
                      onBlur={this._handleValidation}
                      options={[{ value: true, label: 'Active' }, { value: false, label: 'Inactive' }]} // load from BED?
                      // valid={form.type.valid}
                      // value={this.props.personalInfo.personalInfo[0].status}
                      value={form.status.value}
                    />
                  </li>
                  <li>
                    <DateInput
                      {...schema.drawDownStartDate}
                      // error={form.dob.error}
                      disablePast={false}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].draw_down_start_date) ? this.props.personalInfo.personalInfo[0].draw_down_start_date : ''}
                      handleChange={this._handleChange}
                      readonly={false}
                      value={form.drawDownStartDate.value}
                    />
                  </li>
                  <li>
                    <DateInput
                      {...schema.drawDownEndDate}
                      // error={form.dob.error}
                      disablePast={false}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].draw_down_end_date) ? this.props.personalInfo.personalInfo[0].draw_down_end_date : ''}
                      handleChange={this._handleChange}
                      readonly={false}
                      value={form.drawDownEndDate.value}
                    />
                  </li>
                  <li>
                    <SelectInput
                      {...schema.boardMember}
                      handleChange={this._handleSelectChange}
                      onBlur={this._handleValidation}
                      options={[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]} // load from BED?
                      // valid={form.type.valid}
                      // value={this.props.personalInfo.personalInfo[0].board_member}
                      value={form.boardMember.value}
                    />
                  </li>
                  <li>
                    <TextInput
                      {...schema.otherName}
                      // text={(this.props.personalInfo.personalInfo[0].other_name) ? this.props.personalInfo.personalInfo[0].other_name : '-'}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.otherName.value}
                    />
                  </li>
                  <li>
                    <TextInput
                      {...schema.secondedTo}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.secondedTo.value}
                    />
                  </li>
                  <li>
                    <DateInput
                      {...schema.pensionAccrualDate}
                      // error={form.dob.error}
                      disablePast={false}
                      // valid={form.dob.valid}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? moment(this.props.personalInfo.personalInfo[0].pension_accrual_date).format('DD MMM YYYY') : ''}
                      // value={(this.props.personalInfo.personalInfo[0].pension_accrual_date) ? this.props.personalInfo.personalInfo[0].pension_accrual_date : ''}
                      handleChange={this._handleChange}
                      readonly={false}
                      value={form.pensionAccrualDate.value}
                    />
                  </li>
                  <li>
                    <TextInput
                      {...schema.directorId}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.directorId.value}
                    />
                  </li>
                  <li>
                    <TextInput
                      {...schema.allocatedPartnerTaxManager}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.allocatedPartnerTaxManager.value}
                    />
                  </li>
                  <li>
                    <Checkbox
                      {...schema.secondee}
                      // checked={this.props.personalInfo.personalInfo[0].secondee}
                      checked={!!form.secondee.value}
                      handleChange={this._handleChange}
                    />
                  </li>
                  <div className={styles.sectionHeader}>
                  Spouse details
                  </div>
                  <li>
                    <TextInput
                      {...schema.spouseFullLegalName}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.spouseFullLegalName.value}
                    />
                  </li>
                  <li>
                    <TextInput
                      {...schema.spouseDateOfBirth}
                      error={form.spouseDateOfBirth.error}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}                      
                      text={form.spouseDateOfBirth.value}
                    />
                  </li>
                </ul>

              </fieldset>

              <br /><br />
              <div className={styles.footer}>
                <SubmitButton
                  isLarge
                  // disabled={!this.canSubmit()} // Add validation rules
                  complete={this.props.forms[this.props.id]._isComplete}
                  completeText={completeText}
                  submitting={this.props.forms[this.props.id]._isPosting}
                  submittingText={submittingText}
                >
                  {ctaText}
                </SubmitButton>
              </div>
            </form>

          }
        </div>
      </Modal >
    )
  }
}
export default EditPersonalInfoView



// WEBPACK FOOTER //
// ./src/views/PersonalInfo/EditPersonalInfoView.js